/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
// import { DropdownArrowIcon } from '../../../../../images/icons/DropdownArrow/DropdownArrow'
// import OptionsItem from '../../Step05/components/OptionsItem'
import OptionsCheckbox from '../../Step05/components/OptionsCheckbox'
// import { Alert } from '../../../../common/Alert/Alert'

/**
 *     Step main container
 */
export default class VariationOptions extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            values: this.props.values,
            dirty: false,
            errorList: [],
        }
    }

    handleCheckbox = () => {
        return true
    }

    handleItemChange = (field: string, value: any) => {
        if (this.props.dirty) {
            this.props.dirty(true)
        }
        this.setState({
            values: { ...this.state.values, [field]: value },
            dirty: true,
        })
    }

    handleSubmit = (event: any) => {
        event.preventDefault()
        let errorList: any = []
        if (errorList.length !== 0) {
            this.setState({ errorList: errorList })
        } else {
            this.props.handleAdjustChangeOptions(this.state.values)
            this.setState({ dirty: false, errorList: [] })
            if (this.props.dirty) {
                this.props.dirty(false)
            }
        }
    }

    render() {
        return (
            <div>
                <form
                    onSubmit={this.handleSubmit}
                    className={`${this.props.optionsOpen ? 'open' : null}
                    ${this.state.dirty ? 'plus57' : null}
                    ${(this.state.errorList.length) ? 'plus102' : null}`}
                >
                    <div
                        className={`variation__options__content options ${!this.props.optionsOpen ? 'closed' : null}`}
                    >
                        <OptionsCheckbox
                            id="terrorism"
                            title="Add terrorism cover"
                            handleItemChange={this.handleItemChange}
                            checked={this.props.values.terrorism || false}
                            value={this.props.values.terrorism}
                        >
                            Insurers subscribe to Pool Re and, accordingly, if selected cover will extend to all
                            material damage and consequential loss sections.
                        </OptionsCheckbox>

                    </div>
                    <button className={`submit ${this.state.dirty ? 'visible' : null}`} type="submit">Update</button>
                </form>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05c/components/VariationOptions.tsx